module.exports = __webpack_public_path__ + "img/banner01.f5e8d6c1.jpg";